module.exports = __webpack_public_path__ + "img/ETS-Logo-Header.587eb0dc.png";